import React from 'react';
import { GlobeIcon, ShieldIcon, NetworkIcon, ClockIcon, ActivityIcon } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { GlassCard } from '../ui/GlassCard';
const points = [{
  icon: NetworkIcon,
  text: 'Responds to information warfare'
}, {
  icon: GlobeIcon,
  text: 'Addresses social fragmentation'
}, {
  icon: ShieldIcon,
  text: 'Counters propaganda vulnerability'
}, {
  icon: ClockIcon,
  text: 'Seeks long-term civilizational stability'
}, {
  icon: ActivityIcon,
  text: 'Replaces popularity with demonstrated judgment'
}];
export function PoliticalResponse() {
  return <SectionWrapper hasDivider glowPosition="left" data-id="element-157">
      <div className="grid lg:grid-cols-2 gap-16 items-start" data-id="element-158">
        <div className="sticky top-32" data-id="element-159">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white mb-6" data-id="element-160">
            Beyond liberal democracy and traditional authoritarianism
          </h2>
          <p className="text-lg text-slate-400 leading-relaxed" data-id="element-161">
            The Cognarchic State is presented as a response to the failures of
            both liberal democracy and traditional authoritarianism. It treats
            mass irrationality, propaganda susceptibility, emotional
            instability, and declining institutional trust as major civic risks.
            Its answer is not blind equality or brute control, but a
            developmental order centered on the quality of mind within the
            population.
          </p>
        </div>

        <div className="flex flex-col gap-4" data-id="element-162">
          {points.map((point, idx) => <GlassCard key={idx} glowColor="cyan" className="flex items-center gap-4 p-5" data-id="element-163">
              <div className="w-10 h-10 rounded-full bg-cyan-500/10 flex items-center justify-center shrink-0 border border-cyan-500/20" data-id="element-164">
                <point.icon className="w-5 h-5 text-cyan-400" data-id="element-165" />
              </div>
              <span className="text-lg text-slate-200 font-medium" data-id="element-166">
                {point.text}
              </span>
            </GlassCard>)}
        </div>
      </div>
    </SectionWrapper>;
}